import { breakpoints, spacing, siteColors } from './utils';

export default {
  breakpoints,
  spacing,
  fontFamily: {
    base: 'PingFang SC, roboto, sans-serif',
    heading: 'nexa-bold, sans-serif',
    button: 'nexa-bold, sans-serif',
  },
  fontWeights: {
    normal: 400,
    bold: 800,
  },
  colors: {
    ...siteColors,
  },
};
